<script lang="ts">
  import { Button, TextInput } from 'carbon-components-svelte'
  import Maximize from 'carbon-icons-svelte/lib/Maximize20'
  import Minimize from 'carbon-icons-svelte/lib/Minimize20'

  import LobbyStore from '../stores/lobby'

  export let open = false

  let composingMessage = ''
  let { chatMessages, usersOnline } = LobbyStore

  function toggleChat() {
    open = !open
  }
  function pressKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      sendMessage()
    }
  }
  function sendMessage() {
    const messageToSend = composingMessage.trim()
    if (messageToSend) {
      LobbyStore.sendChatMessage(messageToSend)
      composingMessage = ''
    }
  }
  function setInitialPixelHeight(node: HTMLDivElement) {
    node.scrollTop = 100
  }
</script>

<div class="lobby-chat">
  <Button icon={open ? Minimize : Maximize} on:click={toggleChat}>
    Lobby Chat ({$usersOnline})
  </Button>
  {#if open}
    <div class="lobby-chat__body">
      <div class="lobby-chat__messages" use:setInitialPixelHeight>
        {#each $chatMessages as { senderName, message }}
          <div class="lobby-chat__message">
            <b>{senderName}</b>
            <span>{message}</span>
          </div>
        {/each}
        <div class="lobby-chat__anchor" />
      </div>
      <div class="lobby-chat__composer">
        <TextInput
          placeholder="Compose message"
          on:keydown={pressKey}
          bind:value={composingMessage} />
      </div>
    </div>
  {/if}
</div>

<style>
  .lobby-chat {
    position: fixed;
    bottom: 0;
    right: 3rem;
    width: 18rem;
  }
  :global(.lobby-chat > button) {
    width: 100%;
  }

  .lobby-chat__body {
    height: 20rem;
    width: 100%;
    background-color: var(--cds-field-01, #f4f4f4);
    display: flex;
    flex-direction: column;
  }
  .lobby-chat__messages {
    flex-grow: 1;
    overflow-y: scroll;
  }
  .lobby-chat__messages * {
    overflow-anchor: none;
  }
  .lobby-chat__messages::after {
    content: '';
    height: 1px;
    display: block;
    overflow-anchor: auto;
  }
  .lobby-chat__message {
    padding: 0.2rem;
    line-height: 1.2;
    line-break: anywhere;
  }
  .lobby-chat__message b {
    font-weight: 700;
  }
  :global(.lobby-chat__composer input) {
    margin-bottom: 0;
    border-top: 1px solid var(--cds-ui-04, #8d8d8d);
    border-bottom: none;
  }
</style>

